module.exports = __webpack_public_path__ + "img/07.76d33acb.jpg";